import React, { HTMLProps } from 'react';
import clsx from 'clsx';
import './style.scss';
import IconChecked from './icon-checked.svg';
import IconNotChecked from './icon-not-checked.svg';

export interface IRadio extends HTMLProps<HTMLInputElement>{
    className?: string
}

export const Radio: React.FC<IRadio> = (props): JSX.Element => {
    const {
        className = '',
        ...inputProps
    } = props;

    return (
        <div className={clsx('oms-radio', { 'oms-radio-checked': inputProps.checked }, className)}>
            <input {...inputProps} type="radio" />
            {inputProps.checked && (
                <IconChecked />
            )}
            {!inputProps.checked && (
                <IconNotChecked />
            )}
        </div>
    );
};
